@let id = 'users-overview';

<div>
  <div class="flex flex-row items-center justify-between pb-12">
    <div class="text-3xl" [attr.data-testid]="id | appendTestId: 'headline'">
      {{ cmsTextProvider.userOverview.headline }}
    </div>
    <div class="flex w-1/3 flex-row justify-end gap-4">
      <aw-text-input
        id="user-search"
        [label]="cmsTextProvider.shared.search"
        [placeholder]="cmsTextProvider.userOverview.searchPlaceholder"
        [formControl]="globalSearchControl">
      </aw-text-input>
    </div>
  </div>

  <aw-table
    id="users-table"
    [data]="shownUsers()"
    [defaultPageSize]="5"
    [header]="header"
    [rowKey]="userRowKey"
    [expandable]="true"
    expansionMode="multiple"
    [expandedRowTemplate]="expandedRow"
    [columns]="columns"
    [showHeader]="true">
    <ng-template #header let-sortBy="sortBy">
      <aw-table-header cellName="expand" class="w-30"> </aw-table-header>
      <aw-table-header
        cellName="firstName"
        class="w-full"
        [sortParams]="{ attribute: 'firstName', compare: userDataFilter }"
        (onSort)="sortBy($event)">
        <aw-searchable-header
          [label]="cmsTextProvider.userOverview.firstName"
          [control]="firstNameControl"></aw-searchable-header>
      </aw-table-header>
      <aw-table-header
        cellName="lastName"
        class="w-full"
        [sortParams]="{ attribute: 'lastName', compare: userDataFilter }"
        (onSort)="sortBy($event)">
        <aw-searchable-header
          [label]="cmsTextProvider.userOverview.lastName"
          [control]="lastNameControl"></aw-searchable-header>
      </aw-table-header>
      <aw-table-header
        cellName="email"
        class="w-full"
        [sortParams]="{ attribute: 'email', compare: userDataFilter }"
        (onSort)="sortBy($event)">
        <aw-searchable-header
          [label]="cmsTextProvider.userOverview.email"
          [control]="emailControl"></aw-searchable-header>
      </aw-table-header>
      <aw-table-header
        cellName="status"
        class="w-full"
        [sortParams]="{ attribute: 'status', compare: userDataFilter }"
        (onSort)="sortBy($event)">
        {{ cmsTextProvider.userOverview.status }}
        <span class="group relative ml-1">
          <span
            class="material-symbols-rounded cursor-help align-middle text-base text-gray-700 transition-colors group-hover:text-blue-600"
            >info</span
          >
          <div
            class="pointer-events-none absolute bottom-7 left-6 z-20 w-64 min-w-[16rem] rounded-lg bg-gray-800 p-3 text-xs text-white opacity-0 shadow transition-all duration-200 group-hover:pointer-events-auto group-hover:opacity-100">
            <div class="mb-1 text-sm font-semibold">Status Bedeutung</div>
            <ul class="list-disc pl-4">
              <li><b>Offen:</b> Registriert, keine Mail erhalten</li>
              <li><b>Angefragt:</b> Warten auf Bestätigung</li>
              <li><b>Aktiv:</b> Registrierung bestätigt, Login möglich</li>
              <li><b>Deaktiviert:</b> Kein Login möglich</li>
            </ul>
          </div>
        </span>
      </aw-table-header>
      <aw-table-header
        cellName="userId"
        class="w-full"
        [sortParams]="{ attribute: 'userId', compare: userDataFilter }"
        (onSort)="sortBy($event)">
        <aw-searchable-header
          [label]="cmsTextProvider.userOverview.userId"
          [control]="userIdControl"></aw-searchable-header>
      </aw-table-header>
      <div class="flex grow items-center justify-end px-2">
        <button
          type="button"
          class="material-symbols-rounded cursor-pointer text-2xl"
          [ngClass]="{ 'animate-spin': isRefreshing() }"
          (click)="refresh()">
          refresh
        </button>
      </div>
    </ng-template>

    <ng-template
      #columns
      let-data="data"
      let-toggleExpanded="toggleExpanded"
      let-isExpanded="isExpanded"
      let-index="index">
      <aw-table-cell
        cellName="expand"
        class="flex w-full items-center justify-start">
        <button
          type="button"
          (click)="toggleExpanded(data, index)"
          class="flex cursor-pointer items-center justify-center">
          <span class="material-symbols-rounded">
            {{ isExpanded(data, index) ? 'expand_more' : 'chevron_right' }}
          </span>
        </button>
      </aw-table-cell>
      <aw-table-cell cellName="firstName">{{
        data.firstName || '—'
      }}</aw-table-cell>
      <aw-table-cell cellName="lastName">{{
        data.lastName || '—'
      }}</aw-table-cell>
      <aw-table-cell cellName="email">{{ data.email }}</aw-table-cell>
      <aw-table-cell cellName="status">
        <span [ngClass]="getStatusClass(data.status)">{{
          getStatusLabel(data.status)
        }}</span>
      </aw-table-cell>
      <aw-table-cell cellName="userId">{{ data.userId }}</aw-table-cell>
    </ng-template>
    <ng-template #expandedRow let-data="data">
      <div class="text-sm">
        Extra content for {{ data.firstName }} {{ data.lastName }}
      </div>
    </ng-template>
  </aw-table>
</div>
